export const schemaFields = [
    // { "field": "actionCode", "label": "Action Code" },
    // { "field": "afskey", "label": "Afskey" },
    { "field": "airline", "label": "Airline" },
    { "field": "flightNumber", "label": "Flight number" },
    { "field": "stations", "label": "Destination(To/From)" },
    { "field": "scheduledTravelTime", "label": "STAD", "type": "date" },
    // { "field": "officialFlightDate", "label": "Official Flight Date", "type": "date" },
    { "field": "aircraftType", "label": "Aircraft type" },
    { "field": "serviceTypeCode", "label": "Service type code" },
    // { "field": "specialFlightIndicator", "label": "Special Flight Indicator" },
    // { "field": "counterOpeningTime", "label": "Counter Opening Time", "type": "date" },
    // { "field": "counterClosingTime", "label": "Counter Closing Time", "type": "date" },
    // { "field": "loungeOpeningTime", "label": "Lounge Opening Time", "type": "date" },
    // { "field": "loungeClosingTime", "label": "Lounge Closing Time", "type": "date" },
    // { "field": "loungeBoardingTime", "label": "Lounge Boarding Time", "type": "date" },
    // { "field": "finalLoungeTime", "label": "Final Lounge Time", "type": "date" },
    { "field": "standCode", "label": "Stand code" },
    { "field": "loungeCode", "label": "Lounge code" },
    { "field": "aircraftRegnNo", "label": "Aircraft Reg#" },
    { "field": "carousel", "label": "Carousel" },
    { "field": "checkInRow", "label": "Row" },
    { "field": "terminalId", "label": "Terminal" },
    // { "field": "checkInType", "label": "Check In Type" },
    { "field": "remarkCode", "label": "Remark" },
    { "field": "ETA", "label": "ETAD", "type": "date" },
    // { "field": "linkedToFlightNo", "label": "Linked Flight No" },
    // { "field": "lastBagReceivedAt", "label": "Last bag received at", "type": "date" }
];

export const specificStyles = {
    "CDK": {
        "inLineStyle": []
    },
    "CKS": {
        "inLineStyle": []
    },
    "STD": {
        "inLineStyle": []
    },
    "OPE": {
        "inLineStyle": []
    },
    "FCL": {
        "inLineStyle": []
    },
    "FDL": {
        "inLineStyle": []
    },
    "FDP": {
        "inLineStyle": []
    },
    "FLD": {
        "inLineStyle": []
    },
    "CCL": {
        "inLineStyle": []
    },
    "CFB": {
        "inLineStyle": []
    },
    "CLB": {
        "inLineStyle": []
    },
    "CDL": {
        "inLineStyle": []
    },
    "COP": {
        "inLineStyle": []
    },
    "GOP": {
        "inLineStyle": []
    },
    "GCL": {
        "inLineStyle": []
    },
    "GBD": {
        "inLineStyle": []
    },
    "GFC": {
        "inLineStyle": []
    },
    "GCH": {
        "inLineStyle": []
    },
    "DOP": {
        "inLineStyle": []
    },
    "DRO": {
        "inLineStyle": []
    },
    "DCL": {
        "inLineStyle": []
    },
    "DRC": {
        "inLineStyle": []
    },
    "IOP": {
        "inLineStyle": []
    },
    "ICL": {
        "inLineStyle": []
    },
    "FCF": {
        "inLineStyle": []
    },
    "FIN": {
        "inLineStyle": []
    },
    "FDV": {
        "inLineStyle": []
    },
    "FRT": {
        "inLineStyle": []
    },
    "CAR": {
        "inLineStyle": []
    },
    "LCC": {
        "inLineStyle": []
    },
    "ICC": {
        "inLineStyle": []
    },
    "NXT": {
        "inLineStyle": []
    },
    "NXF": {
        "inLineStyle": []
    },
    "KSK": {
        "inLineStyle": []
    },
    "FRB": {
        "inLineStyle": []
    },
    "TST": {
        "inLineStyle": []
    },
    "NTM": {
        "inLineStyle": []
    },
    "GTG": {
        "inLineStyle": []
    },
    "GSH": {
        "inLineStyle": []
    },
    "GCN": {
        "inLineStyle": []
    }
}